<template>
	<div id="patient-avatar-container">
		<img
			id="avatar"
			:src="avatar ?? default_avatar"
			class=""
			@click="OpenModal()"
		/>

		<div
			id="modal-avatar"
			class="modal fade"
		>
			<div class="modal-dialog mw-100 d-flex justify-content-center align-items-center">
				<div class="modal-content p-5">
					<button
						id="close-modal"
						class="btn btn-light btn-sm"
						@click="CloseModal"
					>
						<i class="fal fa-times"></i>
					</button>
					<div class="modal-body d-flex flex-column align-items-center">
						<img
							:src="avatar ?? default_avatar"
							class="rounded-lg"
							style="max-width: 100%; max-height: 100%"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import modalMixin from '@/mixins/modal'

	export default {
		name: 'PatientAvatar',
		mixins: [modalMixin],
		props: {
			avatar: {
				type: String,
				default: null,
			},
		},
		data() {
			return {
				default_avatar: require('@/assets/img/profile.png'),
				modalId: '#modal-avatar',
			}
		},
		methods: {},
	}
</script>

<style lang="scss" scoped>
	#patient-avatar-container {
		width: 100%;
		padding: 0.5rem 1rem;
		display: flex;
		align-items: center;
		border-bottom: 1px solid var(--elementsBorderColor);

		#avatar {
			height: 113px;
			width: 113px;
			object-fit: cover;
			cursor: pointer;
			border-radius: 0.5rem;
		}
	}

	#close-modal {
		position: absolute;
		right: 15px;
		top: 15px;
	}

	@media (min-width: 575.98px) {
		.modal-content {
			width: 75% !important;
		}
	}

	@media (min-width: 1000px) {
		.modal-content {
			max-width: 50% !important;
		}
	}

	@media (min-width: 1500px) {
		.modal-content {
			max-width: 800px !important;
		}
	}
</style>
